import { Injectable } from '@angular/core';
import { Repository } from '@frontend-site/shared/utils';
import { createStore, select, withProps } from '@ngneat/elf';
import { Group } from '@frontend-site/shared/data';
import { GroupsState } from './groups.state';
import { Observable } from 'rxjs';

function createInitialState(): GroupsState {
    return {
        groups: []
    };
}
@Injectable({ providedIn: 'root' })
export class UserGroupStore extends Repository<GroupsState> {
    groupsUsers$: Observable<Group[]> = this.store.pipe(select((state) => state.groups));

    get groups(): Group[] {
        return this.getValue().groups ?? [];
    }

    constructor() {
        super(createStore({ name: 'UserGroupStore' }, withProps<GroupsState>(createInitialState())));
    }

    setGroups(groups: Group[]): void {
        this.update({ groups: groups });
    }
}
